import { render, staticRenderFns } from "./ClickAction.vue?vue&type=template&id=3f4a11ce&scoped=true&"
import script from "./ClickAction.vue?vue&type=script&lang=js&"
export * from "./ClickAction.vue?vue&type=script&lang=js&"
import style0 from "./ClickAction.vue?vue&type=style&index=0&id=3f4a11ce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4a11ce",
  null
  
)

/* custom blocks */
import block0 from "./ClickAction.vue?vue&type=custom&index=0&blockType=slot&v-else=true"
if (typeof block0 === 'function') block0(component)

export default component.exports